import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItems from './home/ListItems'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import styleClasses from '../components/common/common.module.scss'
import cookies from '../utils/cookies'
import { useHistory } from 'react-router-dom'
import { deleteFirebaseToken } from '../firebaseInit'
import { SpotterLogoClosed } from '../images/logo-Spotter-imago'
import { SpotterLogoOpen } from '../images/logo-Spotter'
import appIconSpotter from '../images/logo_spotter-login.png'
import { ArrowIcon } from '../images/arrow.js'
import { LogoutIcon } from '../images/logout'
import ProfileImage from './home/ProfileImage.js'

const drawerWidth = 240

export default function Sidebar({ user }) {
  const history = useHistory()

  const classes = useStyles()
  const [open, setOpen] = React.useState(true)
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }
  return (
    <>
      <CssBaseline />
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.items}>
          {open ? (
            <SpotterLogoOpen
              className={classes.logoOpened}
              width="160px"
              height="48px"
            />
          ) : (
            <SpotterLogoClosed
              className={classes.logoClosed}
              width="30px"
              height="48px"
            />
          )}
          <div
            className={clsx(
              styleClasses.navButton,
              open && styleClasses.navButtonActive
            )}
            onClick={() => (open ? handleDrawerClose() : handleDrawerOpen())}
          >
            <ArrowIcon className={styleClasses.icon} />
            {/* <div
              className={clsx(styleClasses.icon, styleClasses.arrowIcon)}
            ></div> */}
          </div>
          <List className={classes.list}>
            <ListItems drawerOpen={open} />
          </List>
        </div>
        {user && <ProfileImage user={user} />}
        <ListItem
          button
          className={classes.logout}
          onClick={() => {
            cookies.remove('accessToken')
            cookies.remove('user')
            history.push('/login')
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText
            primary="Salir"
            onClick={() => {
              deleteFirebaseToken()
            }}
            classes={{ primary: classes.exit }}
          />
        </ListItem>
      </Drawer>
    </>
  )
}
const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  logoOpened: {
    margin: '52px 0px 22px 20px',
  },
  logoClosed: {
    margin: '48.5px 0px 26px 20px',
  },
  drawerPaper: {
    backgroundColor: theme.palette.secondary.main,
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflowX: 'hidden',
    borderRight: 'none',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  list: {
    margin: 'auto 0',
    padding: 0,
  },
  items: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  logout: {
    margin: '24px 0 16px 10px',
    '&:hover': {
      backgroundColor: '#EDF2FF',
    },
  },
  exit: {
    color: '#3068F9',
  },
}))
